import React from 'react';
import { Typography } from '@mui/material';

const DISPLAY_FONT = '"Foregen", "Roboto Slab", Georgia, serif';

export default function LandingGreeting({ customer, compact = false }) {
  if (!customer) return null;
  const name = customer.f_name || customer.name || 'there';

  return (
    <Typography
      variant="h6"
      component="p"
      sx={{
        fontFamily: DISPLAY_FONT,
        fontWeight: 700,
        fontSize: compact ? '1.35rem' : { xs: '1.25rem', md: '1.5rem' },
        letterSpacing: '-0.02em',
        mb: compact ? 0 : 1,
        mt: compact ? 0 : 1.5,
        color: 'text.primary',
      }}
    >
      Hey {name} 👋
    </Typography>
  );
}
